import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Esto no es manipulación?',
    answer: 'No. The F-Formula se basa en entender dinámicas emocionales reales. No te enseña a fingir ni a presionar. Te enseña a ser auténtico de una forma que genera atracción.'
  }, {
    question: '¿Y si no funciona para mí?',
    answer: 'El sistema está diseñado para cualquier hombre que quiera mejorar sus interacciones. No importa tu experiencia previa. Si seguís las fases, vas a notar cambios.'
  }, {
    question: 'Ya probé otros cursos y no sirvieron.',
    answer: 'La mayoría de los cursos te dan tips sueltos. The F-Formula te da un sistema. La diferencia es el orden y la estructura.'
  }, {
    question: 'Tengo miedo de incomodar a alguien.',
    answer: 'Ese miedo es exactamente lo que te mantiene en la friendzone. The F-Formula te enseña a generar tensión emocional de forma respetuosa y natural.'
  }];
  return <section className="py-32 bg-primary" data-id="element-32">
      <div className="max-w-3xl mx-auto px-6" data-id="element-33">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white mb-16 text-center" data-id="element-34">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`border border-white/5 bg-secondary rounded-lg overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-gold/30' : ''}`} data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-6 text-left focus:outline-none" data-id="element-37">
                <span className={`text-lg font-medium transition-colors ${openIndex === index ? 'text-gold' : 'text-white'}`} data-id="element-38">
                  {faq.question}
                </span>
                <ChevronDown className={`text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-gold' : ''}`} data-id="element-39" />
              </button>

              <AnimatePresence data-id="element-40">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-41">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed border-l-2 border-gold ml-6 mb-4 pl-4" data-id="element-42">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}